import { useState } from 'react'
import { validateFetch } from '../actions'
import { cleanValue } from '../utils'

export default (validationUrl, saveRule) => {
  const [loading, setLoading] = useState()
  const [validated, setValidated] = useState(null)

  const validateRule = async ({ value }) => {
    setValidated(null)
    const query = cleanValue(value)

    try {
      setLoading(true)
      const { status } = await validateFetch({
        body: { query },
        validationUrl
      })

      if (status === 200) {
        setValidated(true)
        saveRule(query)
        setLoading(false)
      }
    } catch (error) {
      // Validate only if scenarios're not founded -> 404 (in this case, in error response, error.code is undefined)
      if (!error.code) {
        setValidated(true)
        saveRule(query)
        setLoading(false)
      } else {
        setValidated(false)
        setLoading(false)
      }
    }
  }

  return { loading, setLoading, validated, validateRule, setValidated }
}
